import React, { FC } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useSortable } from '@dnd-kit/sortable';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CSS } from '@dnd-kit/utilities';

interface SortableItemProps {
  id: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const SortableItem: FC<SortableItemProps> = ({ id, children, onClick, ...props }) => {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    borderRadius: 10,
    overflow: 'hidden',
    maxWidth: 400,
    position: 'relative' as const,
    cursor: 'pointer',
  };

  return (
    <div ref={setNodeRef} style={style} {...props} {...attributes} {...listeners} onClick={onClick}>
      {children}
    </div>
  );
};

export default SortableItem;
